import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgTarget = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 25"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M11.217 13.068v-3.027M21 5.513h-2.23zm-2.23 0v-2.23zm0 0-7.554 7.555zm-4.527 7.555h-3.027zM19.115 10.437c.267.812.411 1.68.411 2.582a8.263 8.263 0 1 1-2.541-5.962"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgTarget);
export default ForwardRef;
